import { IResult } from "../../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { IResultsAnalytics } from "./IResultsAnalytics";
import * as moment from 'moment';
export class ResultsAnalytics implements IResultsAnalytics {
    results: IResult[];
    readonly resultsPerDay = new Map<string, number>();
    constructor(results: IResult[]) {
        this.results = results;
        this.resultsPerDay = this.createResultsPerDay();
        
    }

    getMostSubmissionsInADay(): {count: number, day: number} {
        if (this.results.length === 0) {
            return {
                count: 0,
                day: moment().toDate().getTime()
            };
        }
        let mapArray = Array.from(this.resultsPerDay);
        let highest = mapArray.sort( (a, b) => b[1] - a[1]  )[0];
        if (!isNullOrUndefined(highest) && highest.length === 2) {
            return {
                count: highest[1],
                day: moment(highest[0]).toDate().getTime()
            };
        } else {
            return {
                count: 0,
                day: moment().toDate().getTime()
            };
        }
    }

    getLeastSubmissionsInADay(): {count: number, day: number} {
        if (this.results.length === 0) {
            return {
                count: 0,
                day: moment().toDate().getTime()
            };
        }
        let mapArray = Array.from(this.resultsPerDay);
        let lowest = mapArray.sort( (a, b) => a[1] - b[1]  )[0];
        return {
            count: lowest[1],
            day: moment(lowest[0]).toDate().getTime()
        };
    }

    getAvgSubmissionsPerDay(): number {
        if (this.results.length === 0) {
            return 0;
        }
        if (this.results.length === 0) {
            return 0;
        } else {
            let mapArray = Array.from(this.resultsPerDay);
            if (mapArray.length === 0) {
                return 0;
            }
            return Math.ceil(
                mapArray.map(item => item[1]).reduce( (prev, current) => prev + current) / mapArray.length);
        }
    }

    getAvgScore(): number {
        if (this.results.length === 0) {
            return 0;
        }
        if (isNullOrUndefined(this.results)) {
            return 0;
        } 
        return Math.ceil(
            this.results.map(item => item.score).reduce((prev, current) => prev + current) / this.results.length);
    }

    getHighestScore(): number {
        if (this.results.length === 0) {
            return 0;
        }
        if (isNullOrUndefined(this.results)) {
            return 0;
        } 
        
        return this.results.map(item => item.score).sort((a, b) => b - a)[0];
    }

    getLowestScore(): number {
        if (this.results.length === 0) {
            return 0;
        }
        if (isNullOrUndefined(this.results)) {
            return 0;
        } 
        return this.results.map(item => item.score).sort((a, b) => a - b)[0];
    }
    getSubmissionCountOverTime(): Map<string, number> {      
        return this.resultsPerDay;
    }
    private createResultsPerDay(): Map<string, number> {
        let resultsPerDay = new Map<string, number>();

        this.results.forEach(
            result => {
                let date = result.submit_time.substring(0, result.submit_time.indexOf('T'));
                if ( isNullOrUndefined(resultsPerDay.get(date))) {
                    resultsPerDay.set(date, 0);
                }
                resultsPerDay.set(date, resultsPerDay.get(date) + 1);
            }
        );
        return resultsPerDay;
    }
}


// WEBPACK FOOTER //
// ./src/utility/admin/UsersControls/UsersAnalytics/ResultsAnalytics.ts